/* Controllers */
angular.module('callX').controller('ForgotPasswordCtrl', ['$scope', 'UserService', '$state', 'toaster', function($scope, UserService, $state, toaster) {
    $scope.user = {};

    $scope.sendEmail = function() {
        if ($scope.user.email == undefined) {
            toaster.pop('error', 'Email',  'Email is required.', 2000);
        }
        else {
            var callbacks = {
                success: function (data) {
                    if (data.data == 'Ok') {
                        toaster.pop('success', 'Success', 'Email sent! Please check your email for password reset.');
                        $state.go('access.login');
                    }
                    else {
                        toaster.pop('error', 'Error', data.data);
                    }

                },
                failure: function (data) {
                    toaster.pop('error', 'Error', data.data);
                }
            };
            UserService.forgotPassword($scope.user, callbacks);
        }
    };
  }])
;